import {
  authLogin,
  authLogout
} from '@/api/auth.js'
import router from '@/router'
import CryptoJS from 'crypto-js'
import Cookies from 'js-cookie'
import config from '@/config'
const { homeName } = config

export default {
  namespaced: true, // 启用命名空间&#8203;:contentReference[oaicite:6]{index=6}
  state: {
    token: '',                  // 登录令牌
    tokenName: '',              // 令牌名称
    userId: '',                 // 用户 ID
    roles: [],                  // 角色列表
    permissions: [],            // 权限列表
    userBasic: {
      username: '',  // 必须字段
      id: null,
    },              // 基本信息 user-expansion.user
    userExpand: {},             // 扩展信息 user-expansion.userExpand
    tokenInfo: {},              // tokenInfo 全部对象
    hasLogin: false             // 登录状态标识
  },
  mutations: {
    SET_TOKEN(state, tokenInfo) {
      state.token = tokenInfo.tokenValue
      state.tokenName = tokenInfo.tokenName
      state.tokenInfo = tokenInfo
    },
    SET_USER(state, user) {
      // state.userBasic = user
      // state.userId = user.id

      state.userBasic = {
        username: '',
        ...user // 合并传入数据
      }
    },
    SET_USER_EXPAND(state, expand) {
      state.userExpand = expand
    },
    SET_ROLES(state, roles) {
      state.roles = roles
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions
    },
    SET_LOGIN_STATUS(state, status) {
      state.hasLogin = status
    },
    CLEAR_USER_INFO(state) {
      state.token = ''
      state.tokenName = ''
      state.userId = ''
      state.roles = []
      state.permissions = []
      state.userBasic = {}
      state.userExpand = {}
      state.tokenInfo = {}
      state.hasLogin = false
    }
  },
  getters: {
    getUsername(state) {
      return state.userBasic.username;
    },


    getEmail(state) {  // 新增：获取邮箱
      return state.userBasic.email || '';
    },
  },
  actions: {
    // 登录
    async login({ commit }, { username, password, remember }) {
      try {
        // 重点：MD5 加密
        const md5Password = CryptoJS.MD5(password).toString()

        const res = await authLogin({
          username,
          password: md5Password // 加密后的密码
        })

        if (res.data.code === 200) {
          const data = res.data.data

          // 防御：data 或 userExpansion 可能为 null
          if (!data || !data.tokenInfo || !data.userExpansion) {
            throw new Error('登录返回数据异常，缺少必要字段')
          }

          // 1. 设置 token 及信息
          commit('SET_TOKEN', data.tokenInfo)

          // 2. 设置用户基本信息
          commit('SET_USER', data['userExpansion'].user)

          // 3. 设置扩展信息
          commit('SET_USER_EXPAND', data['userExpansion'].userExpand)

          // 4. 权限 & 角色
          commit('SET_PERMISSIONS', data.permissions)
          commit('SET_ROLES', data.roles)

          // 5. 登录状态标记
          commit('SET_LOGIN_STATUS', true)

          // 备份登录状态到 sessionStorage，防止 localStorage 被意外清除后丢失
          sessionStorage.setItem('hasLogin', 'true')
          sessionStorage.setItem('user_permissions', JSON.stringify(data.permissions))
          sessionStorage.setItem('user_roles', JSON.stringify(data.roles))
          sessionStorage.setItem('user_basic', JSON.stringify(data.userExpansion.user))

          // 记住密码处理
          if (remember) {
            localStorage.setItem('username', username)
            localStorage.setItem('password', password)
          } else {
            localStorage.removeItem('username')
            localStorage.removeItem('password')
          }
          Cookies.set('identity', username)  // 新增 Cookie 设置


          // 7. 根据角色跳转到不同的页面
          if (data.roles.includes('ADM')) {
            // 保留 home 标签，其余清空
            commit(
              'setTagNavList',
              [{
                name: homeName,
                meta: { title: 'Dashboard' } // 可根据你的实际 title 填写
              }],
              { root: true } // ⬅️ 因为你在 user 模块中，必须带上 root:true
            )
            router.push('/SystemSettings/Workbenches') // 角色包含 'ADM' 时跳转到工作台

          } else {
            // router.push('/home-page') // 否则跳转到 home-page
            commit(
              'setTagNavList',
              [{
                name: homeName,
                meta: { title: 'Dashboard' } // 可根据你的实际 title 填写
              }],
              { root: true } // ⬅️ 因为你在 user 模块中，必须带上 root:true
            )
            router.push('/project-page') // 否则跳转到选择项目

          }
        } else {
          this.$notice.error(res.data.msg || '登录失败')
        }
      } catch (err) {
        commit('SET_LOGIN_STATUS', false)
        throw err
      }
    },
    // 登出
    logout({ commit }) {
      // Clear user info from the state
      commit('CLEAR_USER_INFO')

      // Clear session storage
      sessionStorage.clear()
      // localStorage.clear()

      // 清除本地存储
      localStorage.removeItem('vuex')
      localStorage.removeItem('username')

      // ✅ 逐个清除 Cookie
      const cookiesToRemove = [
        'identity',
        'coctoken',
        'company',
        'levelA',
        'levelB',
        'levelC',
        'levelD',
        'levelE',
        'safeTableName',
        'tfstk',
      ]
      cookiesToRemove.forEach((key) => {
        Cookies.remove(key)
      })

      // Call API to logout if needed
      authLogout().then(() => {
        // Redirect to login page
        router.push('/login')
      }).catch(error => {
        console.error('Logout error:', error)
      })
    }
  }
}
